var map = {
	"./ad.png": 8435,
	"./ae.png": 7475,
	"./af.png": 5069,
	"./ag.png": 7947,
	"./al.png": 140,
	"./am.png": 6615,
	"./ao.png": 8355,
	"./ar.png": 3341,
	"./at.png": 5156,
	"./au.png": 4682,
	"./az.png": 3177,
	"./ba.png": 3830,
	"./bb.png": 4446,
	"./bd.png": 6833,
	"./be.png": 1985,
	"./bf.png": 7004,
	"./bg.png": 1369,
	"./bh.png": 9259,
	"./bi.png": 8367,
	"./bj.png": 577,
	"./bm.png": 9530,
	"./bn.png": 2659,
	"./bo.png": 9264,
	"./br.png": 1024,
	"./bs.png": 5098,
	"./bt.png": 4772,
	"./bw.png": 918,
	"./by.png": 7960,
	"./bz.png": 4,
	"./ca.png": 8734,
	"./cd.png": 7364,
	"./cf.png": 9629,
	"./cg.png": 8661,
	"./ch.png": 7900,
	"./chandneighbours.png": 5744,
	"./ci.png": 6299,
	"./ck.png": 8181,
	"./cl.png": 1983,
	"./cm.png": 1174,
	"./cn.png": 8950,
	"./co.png": 412,
	"./cr.png": 891,
	"./cu.png": 4285,
	"./cv.png": 5188,
	"./cy.png": 778,
	"./cz.png": 1906,
	"./dach.png": 2134,
	"./de.png": 2553,
	"./dj.png": 7847,
	"./dk.png": 1601,
	"./dm.png": 7610,
	"./do.png": 8068,
	"./dz.png": 9524,
	"./ec.png": 6218,
	"./ee.png": 7653,
	"./eg.png": 8171,
	"./eh.png": 2475,
	"./en.png": 749,
	"./er.png": 629,
	"./es.png": 4894,
	"./et.png": 2175,
	"./eu.png": 1891,
	"./fi.png": 8771,
	"./fj.png": 4450,
	"./fm.png": 5900,
	"./fr.png": 9871,
	"./ga.png": 6655,
	"./gb.png": 8531,
	"./gd.png": 3323,
	"./ge.png": 5581,
	"./gh.png": 761,
	"./gm.png": 112,
	"./gn.png": 5483,
	"./gq.png": 2373,
	"./gr.png": 6225,
	"./gt.png": 4636,
	"./gw.png": 3128,
	"./gy.png": 2559,
	"./hk.png": 8096,
	"./hn.png": 8750,
	"./hr.png": 8088,
	"./ht.png": 8621,
	"./hu.png": 8835,
	"./id.png": 6839,
	"./ie.png": 6215,
	"./il.png": 2864,
	"./in.png": 5878,
	"./iq.png": 6316,
	"./ir.png": 2990,
	"./is.png": 1210,
	"./it.png": 1590,
	"./je.png": 5745,
	"./jm.png": 3945,
	"./jo.png": 6881,
	"./jp.png": 7385,
	"./ke.png": 4544,
	"./kg.png": 5888,
	"./kh.png": 8920,
	"./ki.png": 8219,
	"./km.png": 3409,
	"./kn.png": 8356,
	"./kp.png": 7779,
	"./kr.png": 4626,
	"./kw.png": 1545,
	"./kz.png": 3949,
	"./la.png": 4345,
	"./lb.png": 9470,
	"./lc.png": 5774,
	"./li.png": 7855,
	"./lk.png": 3763,
	"./lr.png": 9721,
	"./ls.png": 3280,
	"./lt.png": 6474,
	"./lu.png": 8376,
	"./lv.png": 7117,
	"./ly.png": 5579,
	"./ma.png": 6405,
	"./mc.png": 2617,
	"./md.png": 6385,
	"./me.png": 9907,
	"./mg.png": 3024,
	"./mh.png": 6048,
	"./mk.png": 5269,
	"./ml.png": 8241,
	"./mm.png": 6132,
	"./mn.png": 2602,
	"./mr.png": 6961,
	"./mt.png": 7179,
	"./mu.png": 8529,
	"./mv.png": 510,
	"./mw.png": 8050,
	"./mx.png": 1151,
	"./my.png": 1805,
	"./mz.png": 5864,
	"./na.png": 3283,
	"./ne.png": 6461,
	"./ng.png": 4352,
	"./ni.png": 8048,
	"./nl.png": 3472,
	"./no.png": 2745,
	"./no_flag.png": 6862,
	"./np.png": 9423,
	"./nr.png": 3744,
	"./nu.png": 3477,
	"./nz.png": 5799,
	"./om.png": 7019,
	"./pa.png": 68,
	"./pe.png": 7035,
	"./pg.png": 4082,
	"./ph.png": 5467,
	"./pk.png": 8464,
	"./pl.png": 1343,
	"./ps.png": 942,
	"./pt.png": 2670,
	"./pw.png": 8913,
	"./py.png": 1201,
	"./qa.png": 1916,
	"./ro.png": 4481,
	"./rs.png": 5740,
	"./ru.png": 8544,
	"./rw.png": 5245,
	"./sa.png": 2013,
	"./sb.png": 3644,
	"./sc.png": 2499,
	"./sd.png": 5248,
	"./se.png": 4405,
	"./sg.png": 2557,
	"./si.png": 5772,
	"./sk.png": 3044,
	"./sl.png": 1915,
	"./sm.png": 2424,
	"./sn.png": 6084,
	"./so.png": 9298,
	"./sr.png": 7550,
	"./ss.png": 2017,
	"./st.png": 8831,
	"./sv.png": 7974,
	"./sy.png": 8226,
	"./sz.png": 2021,
	"./td.png": 4104,
	"./tg.png": 4863,
	"./th.png": 1307,
	"./tj.png": 4897,
	"./tl.png": 128,
	"./tm.png": 1322,
	"./tn.png": 7257,
	"./to.png": 2174,
	"./tr.png": 1797,
	"./tt.png": 3265,
	"./tv.png": 9354,
	"./tw.png": 1427,
	"./tz.png": 1659,
	"./ua.png": 2357,
	"./ug.png": 7743,
	"./us.png": 3374,
	"./uy.png": 5176,
	"./uz.png": 902,
	"./va.png": 1640,
	"./vc.png": 1522,
	"./ve.png": 669,
	"./vn.png": 3765,
	"./vu.png": 9794,
	"./ws.png": 9307,
	"./xk.png": 84,
	"./ye.png": 194,
	"./za.png": 66,
	"./zm.png": 9241,
	"./zw.png": 3702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7537;